/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ option: NonNullable<unknown> }} Task_Flow_Remove_OptionInputs */

const en_task_flow_remove_option = /** @type {(inputs: Task_Flow_Remove_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.option}`)
};

const pt_br2_task_flow_remove_option = /** @type {(inputs: Task_Flow_Remove_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remover ${i?.option}`)
};

/**
* | output |
* | --- |
* | "Remove {option}" |
*
* @param {Task_Flow_Remove_OptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_remove_option = /** @type {((inputs: Task_Flow_Remove_OptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Remove_OptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_remove_option(inputs)
	return pt_br2_task_flow_remove_option(inputs)
});